import React, {lazy, Suspense, useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

//ICON
import LoadingIcon from "../../../../assets/img/loading-icon-black.svg";

//CSS
import styles from "./VTEspecialExcursion.module.less";

import SpecialExcursions from "./config.js";

function VTEspecialExcursion({excursionInfo, selectedDate, excursionsPrices, getTotalPax, specialExcursion, setSpecialExcursion, debug}) {

  const [t,i18n]  = useTranslation("vtform");
  const [isLoading, setIsLoading] = useState(true);
  const [specialExcursionInfo, setspecialExcursionInfo] = useState(null);
  let Excursion = null;

  if (debug) console.log("####### Special Excursion #######");

  //Recuperamos datos de la excursion cuando se seleccione
  useEffect(() => {
    if (excursionInfo.isSpecialExcursion && SpecialExcursions.hasOwnProperty(excursionInfo.id)){

      const d = selectedDate.getDate() >= 10 ? selectedDate.getDate() : '0' + selectedDate.getDate();
      const m = (selectedDate.getMonth() + 1) >= 10 ? (selectedDate.getMonth()+1) : '0' + (selectedDate.getMonth()+1);
      const dateexcursion= d + '/' + m + '/' + selectedDate.getFullYear();

      //Preparamos datos para envia por POST
      const postdata = new FormData();
      postdata.append('excursionID', excursionInfo.id);
      postdata.append('dateexcursion', dateexcursion);
      postdata.append('numpax', excursionsPrices);

      setIsLoading(true);
      //Recuperamos datos dese el servidor
      fetch(process.env.API_URL + "getSpecialExcursionInfo",{
        method: 'POST',
        body: postdata
      })
        .then((response) =>{
          if (response.ok) { //Verificamos que todo esté bien con la respuesta HTTP
            response.json().then((jsonresponse) => {
              if (debug) console.log("getSpecialExcursionInfo",jsonresponse);
              if(jsonresponse.success){
                setspecialExcursionInfo(jsonresponse.specialExcursionInfo);
              }else{
                console.log('[ef003] Ha ocurrido un error. Intentelo mas tarde');
              }
            });
          } else {
            //Hubo un problema HTTP 4XX o 5XX
            console.log('[ef002] Ha ocurrido un error. Intentelo mas tarde' );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          //Hubo un problema que no permitió hacer la solicitud
          console.log('[ef001] Ha ocurrido un error. Intentelo mas tarde');
        });
    }
  }, [selectedDate, excursionsPrices]);


  if (!excursionInfo.isSpecialExcursion) return null;

  if (SpecialExcursions.hasOwnProperty(excursionInfo.id)) Excursion = SpecialExcursions[excursionInfo.id];
  else return null;

  return (
      <div className={styles.specialexcursions}>
        <div className={styles.title}></div>
        {isLoading && <LoadingIcon className={styles.loadingicon}/>}
        <Excursion
          specialExcursionInfo={specialExcursionInfo}
          getTotalPax={getTotalPax}
          specialExcursion={specialExcursion}
          setSpecialExcursion={setSpecialExcursion}
        />
      </div>
  );
}

export default VTEspecialExcursion;


